import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { LayoutContext } from 'contexts/LayoutContext';
import { View } from 'dripsy';
import { useCallback, useContext, useEffect, useState } from 'react';
import { AccountManagementStackRoutes, AccountManagementStackScreenProps } from '@/features/account-management/account.navigator';
import { ModalContainerView } from '@/features/account-management/components/ModalContainerView';
import { FixedLimitMain } from '@/features/account-management/screens/fixed-limit/FixedLimitMain';
import { FixedLimitConfirm } from '@/features/account-management/screens/fixed-limit/FixedLimitConfirm';
import { FixedLimitPlaced } from '@/features/account-management/screens/fixed-limit/FixedLimitPlaced';
import { FixedLimitStackParamList, FixedLimitStackRoutes } from '@/features/account-management/screens/fixed-limit/type';

const FixedLimitStack = createNativeStackNavigator<FixedLimitStackParamList>();

export const FixedLimitNavigator: React.FC<AccountManagementStackScreenProps<AccountManagementStackRoutes.FixedLimit>> = ({ route }) => {
  const { func, refresh, record } = route.params;
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
  const layout = useContext(LayoutContext);

  useEffect(() => {
    if (!layout.isMobile) return;
    setDimensions(layout.dimensions);
  }, [layout.dimensions]);

  const onLayout = useCallback((event) => {
    const { width, height } = event.nativeEvent.layout;
    setDimensions({ width, height });
  }, []);

  const [data, setData] = useState(undefined);
  const onData = (data: any) => {
    setData(data);
  };

  const [returnData, setReturnData] = useState(undefined);
  const onReturnData = (data: any) => {
    setReturnData(data);
  };

  return (
    <ModalContainerView dimensions={dimensions}>
      <View sx={{ height: dimensions.height, width: dimensions.width }} onLayout={onLayout}>
        <FixedLimitStack.Navigator
          initialRouteName={FixedLimitStackRoutes.Main}
          screenOptions={{
            presentation: layout.isMobile ? 'modal' : 'transparentModal',
            headerShown: false
          }}>
          <FixedLimitStack.Screen
            name={FixedLimitStackRoutes.Main}
            component={FixedLimitMain}
            initialParams={{ onLayout, onData, onReturnData, func, refresh, record }}
            options={{ headerShown: false }}
          />
          <FixedLimitStack.Screen
            name={FixedLimitStackRoutes.Confirm}
            component={FixedLimitConfirm}
            initialParams={{ onLayout, data, onReturnData, func, refresh, record }}
            options={{
              presentation: 'transparentModal',
              headerShown: false,
              contentStyle: {
                backgroundColor: 'transparent'
              }
            }}
          />
          <FixedLimitStack.Screen
            name={FixedLimitStackRoutes.Placed}
            component={FixedLimitPlaced}
            initialParams={{ onLayout, data, returnData, record }}
            options={{ presentation: layout.isMobile ? 'modal' : 'transparentModal', headerShown: false }}
          />
        </FixedLimitStack.Navigator>
      </View>
    </ModalContainerView>
  );
};
